import Color from 'color';

export function getHexCode(colorNames: string): string {
  // Predefined set of colors for "multi" keyword
  const multiColorMap: { [key: string]: string } = {
    //"multi": "red blue green yellow purple orange pink"
  };

  // If the input is "multi", map it to the predefined list of colors
  if (multiColorMap[colorNames.toLowerCase()]) {
    colorNames = multiColorMap[colorNames.toLowerCase()];
  }

  // Split the input by both spaces and slashes
  const colors: string[] = colorNames
    .toLowerCase()
    .trim()
    .split(/[\s/]+/); // Split by spaces or slashes

  // Calculate the average RGB value
  const rgbValues: number[][] = colors
    .map((colorName: string) => {
      try {
        const color = Color(colorName.trim());
        return color.rgb().array(); // Get the RGB array [r, g, b]
      } catch (error) {
        return null; // In case of invalid color, return null
      }
    })
    .filter((color: number[] | null) => color !== null) as number[][]; // Remove invalid colors

  if (rgbValues.length === 0) return '#FFFFF'; // If no valid colors, return an error message

  // Calculate the average RGB values
  const avgRgb: number[] = rgbValues
    .reduce(
      (acc: number[], [r, g, b]: number[]) => {
        acc[0] += r;
        acc[1] += g;
        acc[2] += b;
        return acc;
      },
      [0, 0, 0],
    )
    .map((val: number) => Math.round(val / rgbValues.length)); // Calculate average and round it

  // Convert the average RGB values back to hex
  const averageHex: string = Color.rgb(avgRgb).hex();

  return averageHex; // Return the combined hex code
}
